export interface ITAFBookResponse{
        htmlFileUrl :string;
        pdfFileUrl : string;
        responseStatus :string;
        responseMessage :string;
        responseDisplay: string;
}
export class ITAFBookRequest{
  tafBookId:number;
   constructor(tafBookId: number) {
        this.tafBookId=tafBookId;
    }
}
export class ITAFBookListComponent{
    id:number;
    name:string;
    constructor(id: number, name: string) {
        this.id=id;
        this.name=name;
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book.ts
 **/